import { memoize } from 'lodash' // eslint-disable-line @exodus/restricted-imports/prefer-basic-utils -- TODO: fix next time we touch this file
import { isEthereumLike } from '@exodus/ethereum-lib'

const resultFunction = (assets) => memoize((assetName) => !isEthereumLike(assets[assetName]))

const isZeroFeesEnabledForAssetSelectorDefinition = {
  id: 'isZeroFeesEnabledForAsset',
  resultFunction,
  dependencies: [{ module: 'assets', selector: 'all' }],
}

export default isZeroFeesEnabledForAssetSelectorDefinition
